import React from 'react';
import { cn } from '@/lib/utils';

export interface WideTabPanelProps {
    children: React.ReactNode;
    value: string;
    tabKey: string;
    className?: string;
}

function WideTabPanel({ tabKey, children, value, className }: WideTabPanelProps): React.JSX.Element {
    const isActive = tabKey === value;

    return (
        <div
            role="tabpanel"
            hidden={!isActive}
            data-state={isActive ? 'active' : 'inactive'}
            className={cn('flex-1 text-sm outline-none', className)}
        >
            {isActive ? children : null}
        </div>
    );
}
export default WideTabPanel;
